import React, { memo } from "react";

import { ShowcaseCard, ShowcaseNotice } from "ui/components/Showcase";

import { NOTIFICATION_INTRO_SAMPLE } from "../consts";
import { NotificationSceneProps } from "../types";

/** Korak "Primatelji": tko prima obavijest i kojim kanalima, pa broj odabranih uloga i korisnika. */
const NotificationRecipientsScene: React.FC<NotificationSceneProps> = ({ notification }) => {
  const channelText = notification.activeChannelLabels.join(", ");

  return (
    <>
      <ShowcaseCard className="left-[0.5rem] top-[-1rem] w-[17rem] h-[18rem]" delay={0}>
        <div className="p-5">
          <div className="text-[0.65rem] font-semibold uppercase tracking-wide text-slate-400">Primatelji</div>
          <div className="text-sm font-bold text-slate-800 truncate">{notification.title}</div>
          <div className="mt-3 space-y-2">
            {NOTIFICATION_INTRO_SAMPLE.recipients.map((recipient) => (
              <div key={recipient.name} className="flex items-center gap-2 rounded-md bg-slate-50 px-3 py-2 text-[0.7rem]">
                <span className="flex items-center justify-center w-6 h-6 rounded-full bg-blue-100 text-[0.55rem] font-bold text-blue-700 flex-shrink-0">
                  {recipient.initials}
                </span>
                <div className="min-w-0 flex-1">
                  <div className="font-semibold text-slate-800 truncate">{recipient.name}</div>
                  <div className="text-[0.6rem] text-slate-400 truncate">{recipient.role}</div>
                </div>
                <span className="text-[0.55rem] font-semibold text-amber-700 truncate">{channelText}</span>
              </div>
            ))}
          </div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="right-[-0.5rem] top-[6rem] w-[14rem]" delay={0.25}>
        <div className="p-5">
          <div className="text-[0.65rem] font-semibold uppercase tracking-wide text-slate-400">Odabrano</div>
          <div className="mt-3 space-y-2 text-[0.7rem]">
            <div className="flex items-center justify-between">
              <span className="text-slate-500">Uloge</span>
              <span className="font-semibold text-slate-800">{notification.roleCount}</span>
            </div>
            <div className="flex items-center justify-between">
              <span className="text-slate-500">Korisnici</span>
              <span className="font-semibold text-slate-800">{notification.userCount}</span>
            </div>
            <div className="flex items-center justify-between">
              <span className="text-slate-500">Izuzeti</span>
              <span className="font-semibold text-slate-800">{notification.excludedUserCount}</span>
            </div>
          </div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="left-[-1.5rem] bottom-[-0.5rem] w-[15rem]" delay={0.5}>
        <ShowcaseNotice
          title="Pravi ljudi na vrijeme"
          subtitle="Obavijest ide samo odabranima"
          iconClassName="bg-blue-100"
          icon={
            <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="#1D4ED8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2M9 11a4 4 0 100-8 4 4 0 000 8zM23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75" />
            </svg>
          }
        />
      </ShowcaseCard>
    </>
  );
};

export default memo(NotificationRecipientsScene);
